interface ProgressBarProps {
  /** 0..1, or null when the total is not known yet (shows activity). */
  value: number | null;
  /** Text under the bar. */
  note?: string | null;
  tone?: "accent" | "success" | "danger";
  className?: string;
}

const FILL = {
  accent: "bg-accent",
  success: "bg-success",
  danger: "bg-danger",
} as const;

/** A thin progress bar with an optional one-line note below it. */
export function ProgressBar({ value, note, tone = "accent", className = "" }: ProgressBarProps) {
  return (
    <div className={className}>
      <div className="h-1.5 overflow-hidden rounded-full bg-border">
        {value === null ? (
          <div className={`h-full w-1/3 animate-pulse rounded-full ${FILL[tone]}`} />
        ) : (
          <div
            className={`h-full rounded-full ${FILL[tone]} transition-[width] duration-700`}
            style={{ width: `${Math.round(Math.min(1, Math.max(0, value)) * 100)}%` }}
          />
        )}
      </div>
      {note && (
        <p className="mt-1 truncate text-[11px] text-muted" title={note}>
          {note}
        </p>
      )}
    </div>
  );
}
